/* global wx */


import React, { useEffect, useState, } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container, Grid, Box, CircularProgress } from "@mui/material"
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from "@mui/material/styles";
import { useTheme } from '@mui/material/styles';

import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import YetaiPiece from "../../components/yetaipiece";
import img_test from "../../assets/test.png";
import img_test1 from "../../assets/swiper0.png";
import view0 from "../../assets/view0.jpg";
import view1 from "../../assets/view1.jpg";
import view2 from "../../assets/view2.jpg";
import view3 from "../../assets/view3.jpg";
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { fetchYetaiSearch, ClearSearchData, UpdateDisCityCountroy, UpdateOrderBy, UpdateCurrentPage } from '../../store/features/yetai';
import { useDispatch, useSelector } from 'react-redux';
import { fetchScenic } from '../../store/features/map';

const StyledSelect = styled(Select)(({ theme }) => ({
  color: 'black',
  backgroundColor: 'rgba(255,255,255,1)',
  borderRadius: '5px',
  padding: '2px 4px 2px 6px',
  '& .MuiInput-input': {
    padding: '0 0 0 0 !important',
    backgroundColor: 'red',
  },

  '&:before': {
    border: 'none !important',

  },
  '&:after': {
    border: 'none !important',
    backgroundColor: 'red',
  },
  '& .MuiSelect-icon': {
    color: 'rgb(39,159,91)', // 修改箭头颜色
    top: 'calc(50% - 12px)', // 调整箭头垂直居中
  },
  '& .MuiInput-input': {
    padding: "2px 0px 2px 0px",
    '&:focus': {
      backgroundColor: 'rgba(0, 0, 0, 0.0)', // 聚焦时背景色
    },
  },

  '&.Mui-focused': {
    backgroundColor: 'rgba(255, 255, 255, 1.0)', // 聚焦时背景色
  },
  // '&:not(.Mui-focused)': {
  //   backgroundColor: 'rgba(0, 0, 0, 0.0)', // 失去焦点时背景色
  // },


}));

const StyledLabel = styled((props) => <InputLabel {...props} />)(
  ({ theme }) => ({
    color: 'black',
    zIndex: 9,
    pointerEvents: 'none',
    top: '8px',
    left: '5px',
    fontSize: '0.8rem'
  })
);

const WaterFall = ({ type0, type1, type2 }) => {
  const { dataSearch, hasMore } = useSelector((store) => store.yetai);
  const { loading_search } = useSelector((store) => store.yetai);

  const storageURL = process.env.REACT_APP_Stroage_URL;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type');
  const keyword = queryParams.get('keyword');
  const dispatch = useDispatch();
  let loadingMore = false;
  // 监听滚动事件，滚动到底部时触发加载更多数据
  const handleScroll = () => {
    console.log("type0,type1,type2:", type0, type1, type2)


    const scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    const scrollHeight = (document.documentElement && document.documentElement.scrollHeight) || document.body.scrollHeight;
    const clientHeight = document.documentElement.clientHeight || window.innerHeight;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      if (!loadingMore) {
        loadingMore = true;
        dispatch(fetchYetaiSearch(
          {
            keyword: keyword,
            stype: type,
            district_id: type0,
            city_id: type2,
            county_id: type1,
          }
        )).then(s => {
          setTimeout(() => {
            loadingMore = false;
          }, 500)
        })
      }

    }
  };


  useEffect(() => {
    // 监听滚动事件
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      dispatch(ClearSearchData());
    };
  }, []);

  const leftColumn = dataSearch.filter((_, index) => index % 2 === 0);
  const rightColumn = dataSearch.filter((_, index) => index % 2 !== 0);
  return (
    <Grid>


      <Grid sx={{ padding: 0 }}>
        {/* <ImageList sx={{ marginTop: 1 }}
          variant="masonry" cols={2} gap={12}>
          {
            dataSearch && dataSearch.map((item, index) => (
              <ImageListItem key={index}>
                <YetaiPiece data={item}></YetaiPiece>
              </ImageListItem>
            ))
          }
        </ImageList> */}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <ImageList variant="masonry" cols={1} gap={12}>
              {leftColumn.map((item) => (
                <ImageListItem key={item.id}>
                  <YetaiPiece data={item} />
                </ImageListItem>
              ))}
            </ImageList>
          </Grid>
          <Grid item xs={6}>
            <ImageList variant="masonry" cols={1} gap={12}>
              {rightColumn.map((item) => (
                <ImageListItem key={item.id}>
                  <YetaiPiece data={item} />
                </ImageListItem>
              ))}
            </ImageList>
          </Grid>
        </Grid>
        {
          ((dataSearch && dataSearch.length == 0) || (!hasMore)) &&
          <Box sx={{ color: '#888888', display: 'flex', justifyContent: 'center', marginTop: '1rem', textAlign: 'center' }} >
            没有更多数据
          </Box>
        }
      </Grid>

      {
        loading_search && <Grid sx={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
          <CircularProgress color='mgreen' />
        </Grid>
      }
    </Grid>
  )
}


export default function YeTai() {

  const dispatch = useDispatch();
  const { mapData } = useSelector((store) => (store.maps));
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type');
  const [districtList, SetDistrictList] = useState(null)
  const [countryList, SetCountryList] = useState(null)
  const [nameList, SetNameList] = useState(null)
  // let districtList = [];
  // let countryList = [];
  // let nameList = [];


  const [sortBy, setSortBy] = React.useState('');
  const [type0, setType0] = React.useState('');
  const [type1, setType1] = React.useState('');
  const [type2, setType2] = React.useState('');

  useEffect(() => {
    // if(type0==''&&type1==''&&type2==''){
    //   return
    // }

    dispatch(UpdateDisCityCountroy({
      type0, type1, type2
    }));
    dispatch(UpdateCurrentPage(1));

    if (sortBy == 'coordinate') {
      window.geolocation.getCurrentPosition(function (status, result) {
        console.log('result:', result);
        if (result.info == 'SUCCESS') {
          let { lat, lng } = result.position;
          dispatch(UpdateOrderBy(
            {
              sortBy,
              lat,
              lng
            }
          ));
          dispatch(ClearSearchData());
          dispatch(fetchYetaiSearch(
            {
              // keyword: null,
              keyword: queryParams.get('keyword'),
              stype: type,
              district_id: type0,
              city_id: type2,
              county_id: type1,
              page: 1,
              size: 10,
            }
          ));
        }
        else {
          if (!window.wx_latitude) {
            wx.getLocation({
              type: "gcj02",
              success: function (res) {
                window.wx_latitude = res.latitude;
                window.wx_longitude = res.longitude;
                dispatch(UpdateOrderBy(
                  {
                    sortBy,
                    lat: window.wx_latitude,
                    lng: window.wx_longitude
                  }
                ));
                dispatch(ClearSearchData());
                dispatch(fetchYetaiSearch(
                  {
                    keyword: null,
                    stype: type,
                    district_id: type0,
                    city_id: type2,
                    county_id: type1,
                    page: 1,
                    size: 10,
                  }
                ));
              },
              cancel: function (res) {
                // alert("定位失败，权限不足")
              },
            });

            // if (navigator.geolocation) {
            //   navigator.geolocation.getCurrentPosition(
            //     (position) => {
            //       window.wx_latitude = position.coords.latitude;
            //       window.wx_longitude = position.coords.longitude;
            //       let lat = window.wx_latitude;
            //       let lng = window.wx_longitude;
            //       console.log(lat, lng);
            //       dispatch(UpdateOrderBy(
            //         {
            //           sortBy,
            //           lat: window.wx_latitude,
            //           lng: window.wx_longitude
            //         }
            //       ));
            //       dispatch(ClearSearchData());
            //       dispatch(fetchYetaiSearch(
            //         {
            //           keyword: null,
            //           stype: type,
            //           district_id: type0,
            //           city_id: type2,
            //           county_id: type1,
            //           page: 1,
            //           size: 10,
            //         }
            //       ));
            //     },
            //     (error) => {
            //       // setError(error.message);
            //     }
            //   );
            // } else {

            // }
          }
          else {
            dispatch(UpdateOrderBy(
              {
                sortBy,
                lat: window.wx_latitude,
                lng: window.wx_longitude
              }
            ));
            dispatch(ClearSearchData());
            dispatch(fetchYetaiSearch(
              {
                keyword: null,
                stype: type,
                district_id: type0,
                city_id: type2,
                county_id: type1,
                page: 1,
                size: 10,
              }
            ));
          }

        }

      }, () => { }, { maximumAge: 60000, timeout: 5000, enableHighAccuracy: true });
    }
    else {
      dispatch(UpdateOrderBy(
        { sortBy }
      ));
      dispatch(ClearSearchData());
      dispatch(fetchYetaiSearch(
        {
          keyword: queryParams.get('keyword'),
          // keyword: null,
          stype: type,
          district_id: type0,
          city_id: type2,
          county_id: type1,
          page: 1,
          size: 10,
        }
      ));
    }



  }, [type0, type1, type2, sortBy]);



  const handleChangeSort = (event) => {
    setSortBy(event.target.value);
  }

  const handleChange0 = (event) => {
    setType0(event.target.value);

    let arr_temp = [];
    mapData.forEach((item, index) => {
      if (item.district_id == event.target.value) {
        if (!arr_temp.some(country => (country.id === item.county_id))) {
          arr_temp.push({
            id: item.county_id,
            name: item.county_readable
          });
        }
      }
    });
    SetCountryList(arr_temp);
    console.log("event.target.value:", event.target.value)


  };
  const handleChange1 = (event) => {
    setType1(event.target.value);

    let arr_temp = [];
    mapData.forEach((item, index) => {
      if (item.county_id == event.target.value) {
        if (!arr_temp.some(country => (country.id === item.county_id))) {
          arr_temp.push({
            id: item.county_id,
            name: item.county_readable
          });
        }
      }
    });
    SetNameList(arr_temp);
  };
  const handleChange2 = (event) => {
    setType2(event.target.value);
  };
  const initSelect = (mapData) => {
    let arr_temp0 = [];
    let arr_temp1 = [];
    let arr_temp2 = [];
    mapData && mapData.forEach(item => {
      if (item.district_id != 0 && !arr_temp0.some(temp => (temp.id === item.district_id))) {

        arr_temp0.push({
          id: item.district_id,
          name: item.district_readable
        });
      }
      // if (!arr_temp1.some(country => country.id === item.county_id)) {
      //   arr_temp1.push({
      //     id: item.county_id,
      //     name: item.county_readable
      //   });
      // }
      // if (!arr_temp2.some(name => name === item.name)) {
      //   arr_temp2.push({
      //     name: item.name,
      //     id: item.id
      //   });
      // }
      SetDistrictList(arr_temp0);
      // SetCountryList(arr_temp1);
      // SetNameList(arr_temp2);
    });
  }


  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // 平滑滚动
    });



    if (!mapData) {
      console.log('没数据，去拿一下mapdata')
      dispatch(fetchScenic()).then(s => {
        //有空查一下，如何能等到mapdata自然获得
        if(s.payload)
        {
          initSelect(s.payload.item);
        }
        
      });
    }
    else {
      initSelect(mapData);
    }

    return () => {
      // map?.destroy();
    };

  }, []);

  // const scrollRef = useRef(null);
  // const [data, setData] = useState(null);
  // const [cache, setCache] = useState(null);
  // useEffect(() => {
  //   // 如果缓存中存在数据，则使用缓存
  //   if (cache) {
  //     setData(cache);
  //   } else if (location.state?.from !== 'back') {
  //     fetchData();
  //   }

  //   // 恢复滚动位置
  //   const savedScrollPosition = sessionStorage.getItem('scrollPosition');
  //   if (scrollRef.current && savedScrollPosition) {
  //     scrollRef.current.scrollTop = parseInt(savedScrollPosition, 10);
  //   }

  //   return () => {
  //     // 存储滚动位置
  //     if (scrollRef.current) {
  //       sessionStorage.setItem('scrollPosition', scrollRef.current.scrollTop);
  //     }
  //   };
  // }, [location.state, cache]);

  const theme = useTheme();

  return (
    <Container className='text-mblack' sx={{ marginTop: '5rem' }}>
      {/* <Grid className='flex justify-center' >
        <div style={{display:'flex',justifyContent:'center'}}></div>
        <AntTabs
          value={value}
          onChange={handleChange}
        >
          <AntTab value="1" label="美食" />
          <AntTab value="2" label="农家乐" />
          <AntTab value="3" label="活动" />
        </AntTabs>
      </Grid> */}

      {false&&<Grid className='flex justify-center' alignItems={'center'}>
        <FormControl variant="standard" sx={{ m: 1, minWidth: 60 }} size="small">
          <StyledLabel id="demo-select-small-label" sx={{ fontSize: '0.8rem' }}>排序</StyledLabel>
          <StyledSelect
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={sortBy}
            onChange={handleChangeSort}
            MenuProps={{
              PaperProps: {
                sx: {
                  '& .MuiMenuItem-root': {
                    fontSize: '0.8rem', // 设置下拉菜单项的字体大小
                  },
                  '& .MuiMenuItem-root.Mui-selected': {
                    backgroundColor: 'rgba(0,0,0,0) !important', // 自定义背景颜色
                  },
                  '& .MuiMenuItem-root:hover': {
                    backgroundColor: 'rgba(0,0,0,0)', // 自定义悬停背景颜色
                  },
                  '& .MuiMenuItem-root:focus': {
                    backgroundColor: 'rgba(0,0,0,0)', // 自定义聚焦背景颜色
                  },
                },
              },
            }}
          >
            <MenuItem value="none" sx={{ fontSize: "0.8rem" }}>
              默认
            </MenuItem>
            <MenuItem value="score" sx={{ fontSize: "0.8rem" }}>
              评分
            </MenuItem>
            <MenuItem value="coordinate" sx={{ fontSize: "0.8rem" }}>
              距离
            </MenuItem>
          </StyledSelect>
        </FormControl>

        <FormControl variant="standard" sx={{ m: 1, minWidth: 80 }} size="small">
          <StyledLabel id="demo-select-small-label">区/县</StyledLabel>
          <StyledSelect
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={type0}
            label="Age"
            onChange={handleChange0}
            MenuProps={{
              PaperProps: {
                sx: {
                  '& .MuiMenuItem-root.Mui-selected': {
                    backgroundColor: 'rgba(0,0,0,0) !important', // 自定义背景颜色
                  },
                  '& .MuiMenuItem-root:hover': {
                    backgroundColor: 'rgba(0,0,0,0)', // 自定义悬停背景颜色
                  },
                  '& .MuiMenuItem-root:focus': {
                    backgroundColor: 'rgba(0,0,0,0)', // 自定义聚焦背景颜色
                  },
                },
              },
            }}
          >
            <MenuItem value="0">
              全部
            </MenuItem>
            {
              districtList && districtList.map((item, index) =>
              (
                <MenuItem value={item.id} key={index}>{item.name}</MenuItem>
              ))
            }
          </StyledSelect>
        </FormControl>
        <FormControl variant="standard" sx={{ m: 1, minWidth: 80 }} size="small">
          <StyledLabel id="demo-select-small-label">镇/街道</StyledLabel>
          <StyledSelect
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={type1}
            label="Age"
            onChange={handleChange1}
            MenuProps={{
              PaperProps: {
                sx: {
                  '& .MuiMenuItem-root.Mui-selected': {
                    backgroundColor: 'rgba(0,0,0,0) !important', // 自定义背景颜色
                  },
                  '& .MuiMenuItem-root:hover': {
                    backgroundColor: 'rgba(0,0,0,0)', // 自定义悬停背景颜色
                  },
                  '& .MuiMenuItem-root:focus': {
                    backgroundColor: 'rgba(0,0,0,0)', // 自定义聚焦背景颜色
                  },
                },
              },
            }}
          >
            {
              (type0 == '') ?
                (<MenuItem value="">
                  <p>请选择区/县</p>
                </MenuItem>)
                :
                (<MenuItem value="">
                  <p>全部</p>
                </MenuItem>)
            }
            {
              type0 != '' && countryList && countryList.map((item, index) =>
              (
                <MenuItem value={item.id} key={index}>{item.name}</MenuItem>
              ))
            }
          </StyledSelect>
        </FormControl>
        <FormControl variant="standard" sx={{ m: 1, minWidth: 80 }} size="small">
          <StyledLabel id="demo-select-small-label">乡村</StyledLabel>
          <StyledSelect
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={type2}
            label="Age"
            onChange={handleChange2}
            MenuProps={{
              PaperProps: {
                sx: {
                  '& .MuiMenuItem-root.Mui-selected': {
                    backgroundColor: 'rgba(0,0,0,0) !important', // 自定义背景颜色
                  },
                  '& .MuiMenuItem-root:hover': {
                    backgroundColor: 'rgba(0,0,0,0)', // 自定义悬停背景颜色
                  },
                  '& .MuiMenuItem-root:focus': {
                    backgroundColor: 'rgba(0,0,0,0)', // 自定义聚焦背景颜色
                  },
                },
              },
            }}
          >
            {
              (type1 == '') ?
                (<MenuItem value="">
                  <p>请选择镇/街道</p>
                </MenuItem>)
                :
                (<MenuItem value="">
                  <p>全部</p>
                </MenuItem>)
            }
            {
              type1 != '' && nameList && nameList.map((item, index) =>
              (
                <MenuItem value={item.id} key={index}>{item.name}</MenuItem>
              ))
            }
          </StyledSelect>
        </FormControl>
      </Grid>}
      <WaterFall type0={type0} type1={type1} type2={type2}></WaterFall>

    </Container >
  );
}